class ageVerification extends HTMLElement {
    constructor() {
        super();

        this.element = this;
        this.elements = {
            yesButton: this.querySelector('.age-verification__yes-button'),
            noButton: this.querySelector('.age-verification__no-button'),
            container: this.querySelector('.age-checker__container'),
            errorMessageText: this.querySelector('.age-checker__container').dataset.errorMessage,
            errorMessageField: this.querySelector('.age-verification__error-message'),

            logo: this.querySelector('.age-checker__logo-header'),
            title: this.querySelector('.age-checker__wrapper h2'),
            text: this.querySelector('.age-checker__wrapper p '),
            btn: this.querySelector('.age-checker__btn'),
        }

        this.init();
    }

    init() {
        this.ageVerification();
    }

    ageVerification() {
        if(!document.cookie.includes('ageVerification') && !document.cookie.includes('ageVerification=true')) {
            this.animateIn();
        }

        if(document.cookie.includes('ageVerification=false')) {
            this.setErrorMessage();
            this.animateIn();
        }

        this.elements.yesButton.addEventListener('click', () => {
            this.setCookie('true', 1);
            this.cleanErrorMessage();
            this.animateOut();
        })

        this.elements.noButton.addEventListener('click', () => {
            this.setCookie('false', 1);
            this.setErrorMessage();
        })
    }

    setCookie(value, exdays) {
        document.cookie = `ageVerification=${value}; expires=${exdays}`;
    }

    setErrorMessage() {
        const errorAnim = gsap.timeline({});
        errorAnim.fromTo(this.elements.errorMessageField, 
            {
                duration: 0.5,
                autoAlpha: 0,
                display: 'none',
            },
            {
                autoAlpha: 1,
                display: 'block',
                onComplete: () => {
                    this.elements.errorMessageField.innerHTML = this.elements.errorMessageText;
                }
            }
        );
    }

    cleanErrorMessage() {
        this.elements.errorMessageField.innerHTML = '';
    }

    animate(){
        this.animIn = gsap.timeline({
            ease: "power2.in",
            paused: true,
        });

        this.animIn.fromTo(this, 
            {
                duration: 2.5,
                display: 'none',
                autoAlpha: 0,
            },
            {
                display: 'flex',
                autoAlpha: 1,
            }
        );

        this.animIn.from(this.elements.text,{
            duration: .5,
            blur: 100,
            yPercent: 15,
            ease: "power2.inOut",
        }, 0.2);

        this.animIn.from(this.elements.btn,{
            duration: .7,
            yPercent: 30,
            delay: .08,
            ease: "power2.inOut",
        }, 0.2)
    }

    animateIn() {
        // document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        if (window.lenis != null) {
            window.lenis.stop();
        }

        this.animate();
        this.animIn.play();
    }

    animateOut() {
        // document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';
        if (window.lenis != null) {
            window.lenis.start();
        }
        
        this.animOut = gsap.timeline({
            ease: "power3.out",
        });

        this.animOut.to(this.element, 
            {
                duration: .6,
                autoAlpha: 0,
                display: 'none',
            }
        );
    }
}

customElements.define('age-verification', ageVerification);